import { useMutation } from "@tanstack/react-query";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { debounce } from "lodash";
import { Rating, Slider, Stack } from "@mui/material";
import apis from "../../services";
import { useSelector } from "react-redux";

const FeedbackReviewForm = ({ questions, qrCodeObj, setShowFeedback }) => {
  // console.log("questions", questions);
  const [rating, setRating] = useState(null);
  const [rangeValues, setRangeValues] = useState({});
  const [userEmailValue, setUserEmailValue] = useState("");
  const [emailError, setEmailError] = useState("");
  const { languageCode, translatedData } = useSelector(
    (state) => state?.language
  );
  const validateEmail = (email) => {
    // Basic email regex
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const handleChangeEmail = (e) => {
    const value = e.target.value;
    setUserEmailValue(value);

    // Validate on change
    if (!validateEmail(value)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };
  console.log("userEmailValueuserEmailValue", userEmailValue);
  console.log("languageCodelanguageCodelanguageCode", languageCode);
  console.log("translatedDatatranslatedData", translatedData);

  // Update a specific slider value
  const updateRangeValue = (index, value) => {
    setRangeValues((prev) => ({
      ...prev,
      [index]: value,
    }));
  };

  // Calculate average
  const average =
    questions.length > 0
      ? Math.round(
          questions
            .filter((q) => q.type === "range")
            .reduce((acc, q, i) => acc + (rangeValues[i] ?? 50), 0) /
            questions.filter((q) => q.type === "range").length
        )
      : 0;

  console.log("qrCodeObj", qrCodeObj);

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    register,
    formState: { errors },
  } = useForm();

  //API FOR REVIEW FORM SUBMIT
  const { mutate: mutateReview, isPending: isLoading } = useMutation({
    mutationFn: apis.PostReviews,
    onError: function (error) {
      // console.log("error", error);
      toast.error("An error occurred while submitting your review.");
    },
    onSuccess: ({ data: reviewSubmitSuccess, status }) => {
      // console.log("reviewSubmitSuccess!!:", reviewSubmitSuccess);
      toast.success(
        "Your review has been successfully submitted! Thank you for your feedback."
      );
      setShowFeedback(false);
      questions.forEach((_, index) => {
        setValue(`question-${index}`, "");
      });
      // console.log("Form State after reset:", control._formValues);
    },
  });

  const onSubmit = (data) => {
    // console.log(data, "formloggg");

    // Validate email first
    if (!userEmailValue) {
      setEmailError("Email is required");
      return;
    }

    if (!validateEmail(userEmailValue)) {
      setEmailError("Please enter a valid email address");
      return;
    }

    // Email is valid, clear any previous error
    setEmailError("");

    const answers = Object.entries(data).map(([key, value]) => {
      const questionIndex = key.split("-")[1];
      const questionId = questions[questionIndex]?.id;

      return {
        question_id: questionId,
        // answer: value,
        answer: value !== undefined && value !== null ? String(value) : "", 
        lang: languageCode,
      };
    });

    console.log("answersanswersanswers", answers);

    const payload = {
      answers,
      email: userEmailValue,
      qr_id: qrCodeObj?.id,
    };

    // console.log("Payload to be sent:", payload);

    // payload.forEach((payload) => {
    mutateReview(payload);
    // });
  };

  //API FOR REVIEW RATING STAR
  const { mutate: mutateReviewRating, isPending: isLoadingRating } =
    useMutation({
      mutationFn: apis.PostReviewsRating,
      onError: function (error) {
        // console.log("error", error);
        toast.error("An error occurred while submitting your review.");
      },
      onSuccess: ({ data: reviewSubmitRating, status }) => {
        // console.log("reviewSubmitSuccess!!:", reviewSubmitRating);
      },
    });

  // Debounced API call
  const debouncedMutateReviewRating = React.useCallback(
    debounce((newRating) => {
      mutateReviewRating({
        qr_id: qrCodeObj?.id,
        rating: newRating.toString(),
      });
    }, 900),
    [mutateReviewRating, qrCodeObj?.id]
  );

  const handleRatingChange = (newRating) => {
    setRating(newRating);
    debouncedMutateReviewRating(newRating);
  };
  console.log("questionsquestions", questions);
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="feedbackForm"
      dir={["ur", "hi"].includes(languageCode) ? "rtl" : "ltr"}
    >
      {questions?.some((q) => q.type === "range") && (
        <p className="rate-experience">
          Rate Your Experience:{" "}
          <span style={{ color: "#e0201c" }}>{average}/100</span>
        </p>
      )}

      {questions?.map((question, index) => {
        const translationKey = `question_${index + 1}_text`;
        const questionText = translatedData?.[translationKey] || question.text;

        return (
          <div key={index} className="questionBox">
            {/* <p className="question-text">{question.text}</p> */}
            <p className="question-text">
              {index + 1}. {questionText}
            </p>
            {/* Text Input */}
            {question?.type === "text" && (
              <Controller
                name={`question-${index}`}
                control={control}
                rules={{ required: "This field is required" }}
                render={({ field }) => (
                  <div className="rightside-con">
                    <input
                      {...field}
                      placeholder="Your answer here"
                      className="input-field"
                    />
                    {errors[`question-${index}`] && (
                      <p className="error-message">
                        {errors[`question-${index}`]?.message}
                      </p>
                    )}
                  </div>
                )}
              />
            )}

            {/* Radio Input */}
            {/* {question?.type === "radio" &&
              question?.options.map((option, optIndex) => (
                <label key={optIndex} className="radio-label">
                  <Controller
                    name={`question-${index}`}
                    control={control}
                    rules={{ required: "Please select an option" }}
                    render={({ field }) => (
                      <div className="rightside-con">
                        <input
                          {...field}
                          type="radio"
                          value={option}
                          className="radio-input"
                        />
                        {option}
                        {errors[`question-${index}`] && (
                          <p className="error-message">
                            {errors[`question-${index}`]?.message}
                          </p>
                        )}
                      </div>
                    )}
                  />
                </label>
              ))} */}

            <div className="dropdown-container-flex">
              {question?.type === "radio" &&
                question?.options.map((option, optIndex) => {
                  const translatedOptionKey = `question_${
                    index + 1
                  }_option_${optIndex}`;
                  const translatedOption =
                    translatedData?.[translatedOptionKey] || option;

                  return (
                    <label key={optIndex} className="radio-label">
                      <Controller
                        name={`question-${index}`}
                        control={control}
                        rules={{ required: "Please select an option" }}
                        render={({ field }) => (
                          <>
                            <div className="rightside-con">
                              <input
                                {...field}
                                type="radio"
                                value={translatedOption}
                                className="radio-input"
                                checked={field.value === translatedOption}
                              />
                              {translatedOption}
                            </div>
                            {errors[`question-${index}`] && (
                              <p className="error-message">
                                {errors[`question-${index}`]?.message}
                              </p>
                            )}
                          </>
                        )}
                      />
                    </label>
                  );
                })}
            </div>
            {/* Dropdown Input */}
            {question.type === "dropdown" && (
              <Controller
                name={`question-${index}`}
                control={control}
                rules={{ required: "Please select an option" }}
                render={({ field }) => (
                  <div className="rightside-con">
                    <select {...field} className="input-field">
                      <option value="" disabled>
                        Please Select Option
                      </option>
                      {/* {question.options.map((option, optIndex) => (
                        <option key={optIndex} value={option}>
                          {option}
                        </option>
                      ))} */}

                      {question.options.map((option, optIndex) => {
                        const translatedOptionKey = `question_${
                          index + 1
                        }_option_${optIndex}`;
                        // console.log("translatedOptionKeytranslatedOptionKey",translatedOptionKey)
                        const translatedOption =
                          translatedData?.[translatedOptionKey] || option;

                        return (
                          <option key={optIndex} value={translatedOption}>
                            {translatedOption}
                          </option>
                        );
                      })}
                    </select>
                    {errors[`question-${index}`] && (
                      <p className="error-message">
                        {errors[`question-${index}`]?.message}
                      </p>
                    )}
                  </div>
                )}
              />
            )}

            {/* Checkbox Input */}
            {question.type === "checkbox" && (
              <Controller
                name={`question-${index}`}
                control={control}
                rules={{ required: "Please check this box" }}
                render={({ field }) => (
                  <div className="rightside-con">
                    <input
                      {...field}
                      type="checkbox"
                      className="checkbox-input"
                    />
                    {errors[`question-${index}`] && (
                      <p className="error-message">
                        {errors[`question-${index}`]?.message}
                      </p>
                    )}
                  </div>
                )}
              />
            )}

            {/* Number Input */}
            {question.type === "number" && (
              <Controller
                name={`question-${index}`}
                control={control}
                rules={{
                  required: "Please enter a number",
                  min: { value: 1, message: "Number must be at least 1" },
                  max: { value: 100, message: "Number must be less than 100" },
                }}
                render={({ field }) => (
                  <div className="rightside-con">
                    <input
                      {...field}
                      type="number"
                      placeholder="Number"
                      className="input-field"
                    />
                    {errors[`question-${index}`] && (
                      <p className="error-message">
                        {errors[`question-${index}`]?.message}
                      </p>
                    )}
                  </div>
                )}
              />
            )}

            {/* Email Input */}
            {/* {question.type === "email" && (
              <Controller
                name={`question-${index}`}
                control={control}
                rules={{
                  required: "Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: "Invalid email address",
                  },
                }} // Validation for email input
                render={({ field }) => (
                  <div className="rightside-con">
                    <input
                      {...field}
                      type="email"
                      placeholder="Email"
                      className="input-field"
                    />
                    {errors[`question-${index}`] && (
                      <p className="error-message">
                        {errors[`question-${index}`]?.message}
                      </p>
                    )}
                  </div>
                )}
              />
            )} */}

            {/* Telephone Input */}
            {/* {question.type === "tel" && (
              <Controller
                name={`question-${index}`}
                control={control}
                rules={{
                  required: "Phone number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Invalid phone number (10 digits required)",
                  },
                }} // Validation for tel input
                render={({ field }) => (
                  <div className="rightside-con">
                    <input
                      {...field}
                      type="tel"
                      placeholder="Telephone"
                      className="input-field"
                    />
                    {errors[`question-${index}`] && (
                      <p className="error-message">
                        {errors[`question-${index}`]?.message}
                      </p>
                    )}
                  </div>
                )}
              />
            )} */}

            {/* Password Input */}
            {/* {question.type === "password" && (
              <Controller
                name={`question-${index}`}
                control={control}
                rules={{
                  required: "Password is required",
                  minLength: {
                    value: 6,
                    message: "Password must be at least 6 characters",
                  },
                }} // Validation for password input
                render={({ field }) => (
                  <div className="rightside-con">
                    <input
                      {...field}
                      type="password"
                      placeholder="Password"
                      className="input-field"
                    />
                    {errors[`question-${index}`] && (
                      <p className="error-message">
                        {errors[`question-${index}`]?.message}
                      </p>
                    )}
                  </div>
                )}
              />
            )} */}

            {/* Date Input */}
            {/* {question.type === "date" && (
              <Controller
                name={`question-${index}`}
                control={control}
                rules={{ required: "Date is required" }}
                render={({ field }) => (
                  <div className="rightside-con">
                    <input {...field} type="date" className="input-field" />
                    {errors[`question-${index}`] && (
                      <p className="error-message">
                        {errors[`question-${index}`]?.message}
                      </p>
                    )}
                  </div>
                )}
              />
            )} */}

            {/* Range Input */}
            {question.type === "range" && (
              <Controller
                name={`question-${index}`}
                control={control}
                rules={{ required: "Range value is required" }}
                render={({ field }) => (
                  <div className="rightside-con">
                    <Slider
                      {...field}
                      value={field.value ?? 50}
                      onChange={(_, value) => {
                        field.onChange(value);
                        updateRangeValue(index, value);
                      }}
                      aria-label="Range"
                      valueLabelDisplay="auto"
                      step={1}
                      min={0}
                      max={100}
                      sx={{
                        color: "#e0201c",
                        "& .MuiSlider-thumb": {
                          borderRadius: "50%",
                          "&:hover, &.Mui-focusVisible, &.Mui-active": {
                            boxShadow:
                              "0px 0px 0px 8px rgba(224, 32, 28, 0.16)",
                          },
                        },
                        "& .MuiSlider-track": {
                          border: "none",
                        },
                        "& .MuiSlider-rail": {
                          opacity: 0.28,
                          backgroundColor: "#e0201c",
                        },
                      }}
                    />
                    {errors[`question-${index}`] && (
                      <p className="error-message">
                        {errors[`question-${index}`]?.message}
                      </p>
                    )}

                    <span
                      style={{
                        minWidth: 40,
                        backgroundColor: "#e0201c",
                        color: "#fff",
                        fontWeight: 600,
                        padding: "4px 10px",
                        borderRadius: "999px",
                        textAlign: "center",
                        fontSize: "14px",
                        boxShadow: "0 2px 6px rgba(224, 32, 28, 0.3)",
                      }}
                    >
                      {field.value || 50}
                    </span>
                  </div>
                )}
              />
            )}

            {/* File Input */}
            {/* {question.type === "file" && (
              <Controller
                name={`question-${index}`}
                control={control}
                rules={{ required: "Please upload a file" }}
                render={({ field }) => (
                  <div className="rightside-con">
                    <input {...field} type="file" className="input-field" />
                    {errors[`question-${index}`] && (
                      <p className="error-message">
                        {errors[`question-${index}`]?.message}
                      </p>
                    )}
                  </div>
                )}
              />
            )} */}
          </div>
        );
      })}

      {qrCodeObj?.is_rating === "true" && (
        <div
          style={{
            margin: "16px 0px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            display: "none",
          }}
        >
          <p style={{ fontWeight: "bold", marginBottom: "8px" }}>
            Rate Your Overall Experience
          </p>
          <Stack spacing={1}>
            <Rating
              name="size-medium"
              value={rating}
              precision={0.5}
              onChange={(event, newValue) => handleRatingChange(newValue)}
              disabled={isLoadingRating}
            />
          </Stack>
        </div>
      )}

      <div className="suggestion-box " style={{ display: "none" }}>
        <h3>Would you like to share anything else with us?</h3>
        <textarea name="" id="">
          Your Suggestion
        </textarea>
      </div>
      {/* <input
        type="email"
        placeholder="email address"
        {...register("email", {
          required: "Email is required",
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: "Invalid email address",
          },
        })}
        className="input-field"
      />
      {errors.email && <p className="error-message">{errors.email.message}</p>} */}

      <div className="user-email-field" style={{ direction: "ltr" }}>
        <input
          type="email"
          name="email"
          id=""
          placeholder="email address"
          value={userEmailValue}
          onChange={handleChangeEmail}
          className={emailError ? "input-error-email" : ""}
        />
        {emailError && <p className="error-text-email">{emailError}</p>}
      </div>
      {questions.length > 0 && (
        <button type="submit" className="submit-btn" disabled={isLoading}>
          {isLoading ? "Submitting..." : "Submit"}
        </button>
      )}
    </form>
  );
};

export default FeedbackReviewForm;
